// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"237":"c71e7aed","880":"134a8e51"}[chunkId] + ".css";
};